<template>
    <section>
        <div class="f fh fa-c sm-b-xl">
            <ButtonIcon v-if="!sideBySideMode"
                class="sm-r-s"
                icon="chevron-left"
                @click="goBackToSections" />
            <span class="fg te-fat-section">{{ lbl | athT }}</span>
        </div>
        <template v-if="isV2MultiSection">
            <DashboardConfigSection v-for="(section, index) in allowedChildren"
                :key="index"
                :config="config"
                :dashboardType="dashboardType"
                :dashboard="dashboard"
                :widgetType="widgetType"
                :section="section"
                @onUpdate="onUpdate" />
        </template>
        <template v-else>
            <comp v-for="(component, index) in allowedChildren"
                :key="index"
                :config="config"
                :dashboardType="dashboardType"
                :dashboard="dashboard"
                :widgetType="widgetType"
                v-bind="component.config"
                :is="getWidgetComponent(component)"
                class="sm-b-l"
                @onUpdate="onUpdate" />
        </template>
    </section>
</template>
<script>
import { isNeString } from '@aretheyhappy/utils';
import ButtonIcon from '../../../atoms/ButtonIcon.vue';
import DashboardItemConfigMixin from '../mixins/DashboardItemConfigMixin.js';
import DashboardConfigSection from './DashboardConfigSection.vue';

/**
 * This component is meant to show multiple sub configs inside of it.
 * Children should be an array of DashboardWidgetConfigurationSection.
 *
 * Children components should use DashboardItemConfigMixin.
 */
export default {
    name: 'mead-multi-config-display',
    mixins: [DashboardItemConfigMixin],
    components: {ButtonIcon, DashboardConfigSection},
    props: {
        /**
         * Localization key or label text shown as the heading above this group of
         * sub configs.
         */
        lbl: {type: String, default: '' },
        /**
         * Array of child section/widget definitions to render. Each entry may carry
         * showInEditMode / showInFilterMode flags controlling when it is displayed,
         * plus a component (or component_key) and its config.
         */
        children: {type: Array, default: () => []},
        /**
         * Whether the dashboard is currently in edit mode. Used to filter children
         * to those flagged showInEditMode versus showInFilterMode.
         */
        editMode: {type: Boolean, default: true},
        /**
         * Whether children should be rendered as v2 DashboardConfigSection components
         * (true) or resolved directly as legacy widget components (false).
         */
        isV2MultiSection: {type: Boolean, default: false},
    },
    methods: {
        onUpdate (key, value) {
            this.sendConfigUpdate(key, value);
        },
        getWidgetComponent: function (child) {
            if (child.component) return child.component;
            if (!isNeString(child.component_key)) return false;
            return MeadCommon.DashboardService.getDashboardWidgetComponent(child.component_key);
        }
    },
    computed: {
        allowedChildren: function () {
            const children = [];
            for (const child of this.children) {
                if (this.editMode && child.showInEditMode) children.push(child);
                else if (!this.editMode && child.showInFilterMode) children.push(child);
            }
            return children;
        },
    }
};
</script>
